<template>
  <div class="seomain">
		<st-header
		  :title="(mode == 0 ? 'SZ' : 'HK') + '发货记录'"
		  :back-able="true"
		>
		  <template slot="header-right">
				<span class="search-icon-span">
					<!-- <van-icon name="search" @click="showSearch = true"/> -->
				</span>
		  </template>
		</st-header>
   
    <div class="tab-content tab-content-list">
			<!-- 搜索 多行 -->
			<div class="keyword" v-if="showSearch">
			  <van-form @submit="submitKeyword">
			    <van-field v-model="searchData.order_code" label="单号" placeholder="请输入单号" />
			    <van-field v-model="searchData.sku" label="SKU" placeholder="SKU" />
			    <div :style="{ padding: '16px', backgroundColor: '#fff' }">
			      <van-button round block type="info" native-type="submit">搜 索</van-button>
			    </div>
			  </van-form>
				<div style="text-align: center;background-color: white;">
					<div style="margin: 0px 24px;border-top: 1.5px solid #52596e;">
						<span @click="showSearch = false" style="color: grey!important;font-size: 18px;font-weight: 900;padding: 0px 160px;">
							<van-icon name="arrow-up" />
						</span>
					</div>
					
				</div>
			</div>
			
      <div class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
						<div class="st-list-top st-list-top-with-action">
							<div class="t-tit">{{ v.ordercode }}</div>
						</div>
            <div class="st-list-main">
              <div class="st-field"><span class="st-field-label">批次号</span><span class="st-field-value">{{ v.batch || '--' }}</span></div>

							<div class="st-sku-panel">
                <div class="st-sku-panel-title">SKU明细</div>
								<div class="st-sku-card" v-for="(sku, sku_i) in v.list" :key="'sku' + sku_i">
									<div class="st-sku-name">{{ sku.sku || '--' }}</div>
									<div class="st-sku-meta">
                    <span>Origin: {{ sku.origin || '--' }}</span>
                    <span>Description: {{ sku.description || '--' }}</span>
                    <span>Dimension(CM): {{ sku.dimension || '--' }}</span>
                    <span>GW(KG): {{ sku.gross_weight || '--' }}</span>
                    <span>Quantity: {{ sku.send_total || 0 }}</span>
                  </div>
								</div>
							</div>
              <div class="st-field"><span class="st-field-label">运输方式</span><span class="st-field-value">{{ $option.getText($option.transtype, v.trans_type.toString()) }}</span></div>
              <div class="st-field"><span class="st-field-label">送货方式</span><span class="st-field-value">{{ $option.getText($option.deliverymethods, v.delivery.toString()) }}</span></div>
              <div class="st-field"><span class="st-field-label">物流公司</span><span class="st-field-value">{{ v.logistic_name || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流单号</span><span class="st-field-value">{{ v.courier || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流费用</span><span class="st-field-value">{{ v.shipping || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">收件人</span><span class="st-field-value">{{ v.receiver || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">联系电话</span><span class="st-field-value">{{ v.phone || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">收货地址</span><span class="st-field-value">{{ v.address || '--' }}</span></div>
            </div>
          </div>
        </van-list>
      </div>
      
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
export default {
  components: {
		"st-header": StHeader,
	},
  props: {},
  data() {
    return {
			loading: false,
			showSearch: false,
			searchData: {
				order_code: "",
				sku: "",
				id: "",
			},
			stlist: [],
			page: 1,
			finished: false,
			mode: this.$route.params.mode,
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list() {
      this.stlist = [];
      this.onLoad();
    },
    init() {
			this.searchData.id = this.$route.params.id;
			this.get_st_list();
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("saleo_activeIndex", value);
    },
    // 分页
    async onLoad() {
			this.loading = true;
			let params = this.searchData;
			params['page'] = this.page;
			params['type'] = this.mode;
      let result = await this.$post(this.$api.stGetFaHuoSendlog, params);

      if (result.data.rows == 0) return (this.finished = true);
      // 进行操作
      this.stlist.push(...result.data.rows);
      // 操作完成
			this.page++;
      this.loading = false;
    },
		
		goUrl(url) {
      this.$router.push(url);
      return;
    },
    
    onSearch() {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "销售出库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
div {
	box-sizing: border-box;
}
.search-icon-span .van-icon {
	font-size: 24px!important;
	color: #1a89fa;
	margin: 8px 12px;
	font-weight: 900;
}
.keyword {
  position: sticky;
	top:90px;
  width: 100%;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 0px;
	position: relative;
	top:20px;
	
	.st-list {
		margin: 12px 24px;
		border-radius: 5px;
	}
}

/* 2行input  end */

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyl-btn.active {
  background: #677588;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.st-diyl-btn.checkBy {
  background-color: #677588;
}

.st-list-top-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.st-list-top-with-action .t-tit {
  flex: 1;
  min-width: 0;
}

.st-list-del {
  flex: 0 0 auto;
  color: #f2484b;
  font-size: 28px;
  line-height: 1;
}

.st-list-main {
  padding-top: 4px;
  padding-bottom: 4px;
}

.st-field {
  display: flex;
  align-items: flex-start;
  padding: 6px 0;
  font-size: 14px;
  line-height: 1.5;
  border-bottom: 1px dashed #f1f3f7;
}

.st-field-label {
  flex: 0 0 90px;
  color: #7d8697;
}

.st-field-label::after {
  content: "：";
}

.st-field-value {
  flex: 1;
  min-width: 0;
  color: #394150;
  word-break: break-all;
}

.st-sku-panel {
  margin: 8px 0 6px;
}

.st-sku-panel-title {
  font-size: 14px;
  font-weight: 600;
  color: #394150;
  margin-bottom: 8px;
}

.st-sku-card {
  padding: 10px 12px;
  margin-bottom: 8px;
  background: #f7f9fc;
  border-radius: 8px;
}

.st-sku-card:last-child {
  margin-bottom: 0;
}

.st-sku-name {
  font-size: 16px;
  font-weight: 600;
  color: #2f3747;
  margin-bottom: 8px;
  word-break: break-all;
}

.st-sku-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  font-size: 12px;
  color: #5f6b7a;
}

.st-sku-meta span {
  display: inline-block;
}

.st-pack-btn {
  background-color: rgb(229 134 19);
  margin-left: 0;
}
</style>
